import React from 'react';

const Ticker = () => {
  // Array of logo URLs (SVGs from Simple Icons)
  const logoItems = [
    '../images/annoucement/bar1_1_1.webp', 
    '../images/annoucement/bar1_1_2.webp', 
    '../images/annoucement/bar1_1_3.webp', 
    '../images/annoucement/bar1_1_4.webp', 
    '../images/annoucement/bar1_1_5.webp', 
    '../images/annoucement/squarespace.png',
    '../images/annoucement/aws.png', 
    '../images/annoucement/azure.png', 
    '../images/annoucement/chatgpt.png',
    '../images/annoucement/meta.png',
    '../images/annoucement/wix.png',
    '../images/annoucement/wordpress.png',
    
    

  ];

  // Duplicate the items for smooth scrolling (to create seamless loop)
  const repeatedItems = [...logoItems, ...logoItems];

  return (
    <div className="relative ticker-wrapper border bg-[#fff] overflow-hidden">
      <div className="py-6  ticker-track animate-marquee whitespace-nowrap">
        {repeatedItems.map((logo, index) => (
          <div
            key={index}
            className="ticker-item flex items-center justify-center mx-2 md:mx-6 min-w-[150px]"
          >
            <img src={logo} alt={`Tech logo ${index}`} className="h-12" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Ticker;
